export default {
  common__validation__is_required: 'Field is required',
  common__validation__invalid_format: 'Incorrect value',
  common__validation__invalid_file_size: 'File size exceeds the maximum limit ({size})',
};
